import * as React from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import InformationCircle from "../../../assets/images/info-circle.svg";
import { ITemplate } from "../../../common/types/templateTypes";
import { IAlertTypes } from "../../../common/types/alertsTypes";
import { templateToAlertType } from "../../../common/templateColorVariants";

interface ChooseTemplateProps {
  onNextTab: () => void;
  onClose: () => void;
  isTemplateDivSelected: (template: IAlertTypes) => boolean;
  handleTemplateClick: (templateData: IAlertTypes) => void;
  isTemplateTabFilled: boolean;
  displayTemplates: ITemplate[];
}

const ChooseTemplate = ({
  onNextTab,
  onClose,
  isTemplateDivSelected,
  handleTemplateClick,
  isTemplateTabFilled,
  displayTemplates,
}: ChooseTemplateProps) => {
  const [searchText, setSearchText] = React.useState("");

  const handleNextButtonClick = () => {
    onNextTab();
  };

  const filteredTemplates = displayTemplates.filter((t) =>
    t.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <div>
      <div className="choose_template_container">
        <div className="choose-templates">
          <input
            placeholder="Search Template"
            aria-invalid="false"
            className="search-box"
            type="text"
            data-testid="…"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <div className="alerts-card-content">
            {filteredTemplates.length === 0 ? (
              <div className="no-templates-message">No templates found</div>
            ) : (
              <Row className="gx-3 gy-4">
                {filteredTemplates.map((template) => {
                  const alertType = templateToAlertType(template);
                  return (
                    <Col xs={12} sm={6} lg={4} key={template.templateId}>
                      <div
                        className={`alerts-cards ${
                          isTemplateDivSelected(alertType) ? "highlighted" : ""
                        }`}
                        onClick={() => handleTemplateClick(alertType)}
                      >
                        <div className="alerts-teritary">
                          {template.imageUrl ? (
                            <img
                              src={template.imageUrl}
                              alt={template.name}
                              className="alerts-image"
                            />
                          ) : (
                            <span>No image</span>
                          )}
                        </div>
                        <div className="alerts-label">
                          <div
                            className="alerts-label-text"
                            title={template.name}
                          >
                            {template.name}
                          </div>
                          <div className="alerts-label-adv">
                            {template.metadata?.firmwareVersion && (
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <Tooltip id={`fw-tooltip-${template.templateId}`}>
                                    Supported Firmware Version{" "}
                                    {template.metadata.firmwareVersion} and above.
                                  </Tooltip>
                                }
                              >
                                <span
                                  style={{ cursor: "pointer", color: "#212EA3" }}
                                >
                                  <img
                                    src={InformationCircle}
                                    alt="Info"
                                    width={18}
                                    height={18}
                                  />
                                </span>
                              </OverlayTrigger>
                            )}
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
          </div>
        </div>
      </div>
      <div>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onClose}>
            Cancel
          </Button>
          <Button
            className="btn-style"
            onClick={handleNextButtonClick}
            disabled={!isTemplateTabFilled}
          >
            Next
          </Button>
        </Modal.Footer>
      </div>
    </div>
  );
};

export default ChooseTemplate;
